import { render, staticRenderFns } from "./reservationModel.vue?vue&type=template&id=9c5341c0&scoped=true&lang=pug&"
import script from "./reservationModel.vue?vue&type=script&lang=js&"
export * from "./reservationModel.vue?vue&type=script&lang=js&"
import style0 from "./reservationModel.vue?vue&type=style&index=0&id=9c5341c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5341c0",
  null
  
)

export default component.exports